module.exports = __webpack_public_path__ + "images/6cc1a74118b47e75095ab4d9b7c4e606.png";